<template>
  <div class="create-category-dialog">
    <!-- 智能推荐未匹配提示 -->
    <div class="no-match-hint">
      <div class="hint-icon">🤔</div>
      <div class="hint-text">
        <p>{{ $t('category.noMatch') }}</p>
        <p class="hint-sub">{{ $t('category.noMatchSub') }}</p>
      </div>
    </div>

    <!-- 创建新分类表单 -->
    <div class="create-form">
      <div class="form-item">
        <label>{{ $t('category.productName') }}</label>
        <input 
          type="text" 
          :value="productName"
          disabled
          class="input-disabled"
        />
      </div>

      <div class="form-item">
        <label>{{ $t('category.suggestName') }} *</label>
        <input 
          type="text" 
          v-model="formData.suggestedCategory"
          :placeholder="$t('category.suggestPlaceholder')"
          maxlength="20"
        />
      </div>

      <div class="form-item">
        <label>{{ $t('category.selectIcon') }} *</label>
        <div class="icon-selector">
          <div 
            v-for="icon in iconList" 
            :key="icon"
            :class="['icon-option', { active: formData.suggestedIcon === icon }]"
            @click="formData.suggestedIcon = icon"
          >
            {{ icon }}
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button class="btn-cancel" @click="$emit('cancel')">{{ $t('common.cancel') }}</button>
        <button class="btn-submit" @click="submitCategory" :disabled="submitting">
          {{ submitting ? $t('category.submitting') : $t('category.submitApply') }}
        </button>
      </div>

      <div class="form-tips">
        <p>💡 {{ $t('category.tipAudit') }}</p>
        <p>⏱️ {{ $t('category.tipTime') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'CreateCategoryDialog',
  
  props: {
    productName: {
      type: String,
      required: true
    },
    userId: {
      type: Number,
      required: true
    }
  },
  
  data() {
    return {
      formData: {
        suggestedCategory: '',
        suggestedIcon: '📦'
      },
      submitting: false,
      iconList: ['📦', '🍎', '🥬', '🥩', '🐟', '🍚', '🧂', '🥛', '🍞', '🧊', '🍬', '🥜', '🍰', '☕']
    };
  },
  
  methods: {
    async submitCategory() {
      // 验证
      if (!this.formData.suggestedCategory?.trim()) {
        this.$message.error('请输入分类名称');
        return;
      }
      
      if (!this.formData.suggestedIcon) {
        this.$message.error('请选择图标');
        return;
      }
      
      this.submitting = true;
      
      try {
        await api.post('/admin/category-audit', {
          userId: this.userId,
          productName: this.productName,
          suggestedCategory: this.formData.suggestedCategory,
          suggestedIcon: this.formData.suggestedIcon
        });
        
        this.$message.success('✅ 提交成功！等待管理员审核');
        this.$emit('submit-success');
      } catch (error) {
        console.error('提交失败:', error);
        this.$message.error(error.response?.data?.message || '提交失败，请重试');
      } finally {
        this.submitting = false;
      }
    }
  }
};
</script>

<style scoped>
.create-category-dialog {
  padding: 20px;
}

.no-match-hint {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);
  border: 2px solid #fdba74;
  border-radius: 12px;
  margin-bottom: 24px;
}

.hint-icon {
  font-size: 32px;
}

.hint-text {
  flex: 1;
}

.hint-text p {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #9a3412;
}

.hint-sub {
  font-size: 12px;
  font-weight: normal;
  color: #c2410c;
  margin-top: 4px !important;
}

.create-form {
  max-width: 500px;
}

.form-item {
  margin-bottom: 20px;
}

.form-item label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
}

.form-item input {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  transition: all 0.2s;
  box-sizing: border-box;
}

.form-item input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.input-disabled {
  background: #f3f4f6;
  color: #9ca3af;
  cursor: not-allowed;
}

.icon-selector {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 8px;
}

.icon-option {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  background: #f9fafb;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.icon-option:hover {
  background: #f3f4f6;
  border-color: #d1d5db;
}

.icon-option.active {
  background: #e0e7ff;
  border-color: #6366f1;
  transform: scale(1.1);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.btn-cancel,
.btn-submit {
  padding: 10px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.btn-cancel {
  background: #f3f4f6;
  color: #6b7280;
}

.btn-cancel:hover {
  background: #e5e7eb;
}

.btn-submit {
  background: linear-gradient(135deg, #6366f1, #8b5cf6);
  color: white;
  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.3);
}

.btn-submit:hover:not(:disabled) {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(99, 102, 241, 0.4);
}

.btn-submit:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.form-tips {
  margin-top: 16px;
  padding: 12px 16px;
  background: #f0f9ff;
  border-left: 3px solid #0284c7;
  border-radius: 6px;
}

.form-tips p {
  margin: 4px 0;
  font-size: 12px;
  color: #0c4a6e;
}
</style>
